import classes from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Image, Paper, Stack, Tabs, Text, TextInput, Title } from '@mantine/core';
import { ClaimButton } from '../ClaimButton';
export const Referrals: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Tabs.Panel value="referrals">
      <Paper radius={5} bg="var(--bg-600)" p={38} w={{
      base: '100%',
      sm: 722,
      lg: 650
    }} mx="auto">
        <Stack justify="center" align="center" gap={0}>
          <Title fz={20} className={gunterzBold.className} c="var(--text-white)" ta="center">
            {i18n._('Apply')}
            <Text span inherit c="var(--text-prime)">
              {i18n._(' referral Code')}
            </Text>
          </Title>

          <Box>
            <Image src="/assets/wallet/referral.svg" alt="referral" w={{
            base: 210,
            sm: 244
          }} h={{
            base: 188,
            sm: 244
          }} />
          </Box>
          <TextInput w={{
          base: 348,
          sm: 474,
          lg: 466
        }} classNames={{
          input: classes.input_style_1
        }} ta="center" placeholder={i18n._('add your code here')} />
          <ClaimButton />
        </Stack>
      </Paper>
    </Tabs.Panel>;
};